import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';

const changeLogsService = {
  getAll: async function (page = 1, limit = 20) {
    const offset = (page - 1) * limit;
    return (
      await api_fetch.get(
        `/v1/change-logs?limit=${limit}&offset=${offset}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  getById: async function (id) {
    return (
      await api_fetch.get(
        `/v1/change-logs/${id}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  search: async function (params = {}) {
    const queryParams = new URLSearchParams();

    if (params.page)
      queryParams.append('offset', (params.page - 1) * (params.limit || 20));
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.table_name) queryParams.append('table_name', params.table_name);
    if (params.action) queryParams.append('action', params.action);
    if (params.changed_by) queryParams.append('changed_by', params.changed_by);
    if (params.change_source)
      queryParams.append('change_source', params.change_source);
    if (params.date_filter_start)
      queryParams.append('date_filter_start', params.date_filter_start);
    if (params.date_filter_end)
      queryParams.append('date_filter_end', params.date_filter_end);
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_order) queryParams.append('sort_order', params.sort_order);

    return (
      await api_fetch.get(
        `/v1/change-logs/search?${queryParams.toString()}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  getDistinctTableNames: async function () {
    return (
      await api_fetch.get(
        `/v1/change-logs/table-names`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  getDistinctChangeSources: async function () {
    return (
      await api_fetch.get(
        `/v1/change-logs/change-sources`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  getDistinctChangedBy: async function () {
    return (
      await api_fetch.get(
        `/v1/change-logs/changed-by`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  }
};

export default changeLogsService;
